<template>
	<div>
		<modalconfirm ref="modalReceiveReturDelivery" @action="receiveDelivery"></modalconfirm>
		<modalconfirm noconfirm ref="modalInfoReceiveReturDelivery"/>
		<div class="text-h5">Penerimaan Retur</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
					{{alert.message}}
				</v-alert>
				<v-form>
					<v-row>
						<v-col cols="12" sm="4" md="4">
							<v-autocomplete item-value="pdor_code" hide-details @change="getDetail(pdor_code)" v-model="pdor_code" :items="RDforReceive" label="Kode Retur" :error-messages="responseError.pdor_id" @focus="responseError.pdor_id = ''" outlined dense color="primary" no-data-text="Belum ada data tersedia">
								<template v-slot:item = {item}>
									{{item.pdor_code}} - {{item.supplier_name}}
								</template>
								<template v-slot:selection = {item}>
									{{item.pdor_code}}
								</template>
							</v-autocomplete>
						</v-col>
						<v-col cols="12" v-if="Object.keys(detailRD).length > 0">
							<div class="font-weight-bold">Detail Supplier</div>
							<v-row>
								<v-col cols="12" sm="3" md="3">
									<div class="d-flex">
										<v-icon>mdi-warehouse</v-icon>
										<div class="pl-3">{{ detailRD.supplier_name }}</div>
									</div>
								</v-col>
								<v-col cols="12" sm="3" md="3">
									<div class="d-flex">
										<v-icon>mdi-phone</v-icon>
										<div class="pl-3">{{ detailRD.supplier_mobilephone }}</div>
									</div>
								</v-col>
								<v-col cols="12" sm="6" md="6">
									<div class="d-flex">
										<v-icon class="icon-align-top">mdi-map-marker</v-icon>
										<div class="pl-3">{{ addresText }}</div>
									</div>
								</v-col>
							</v-row>
						</v-col>
						<v-col cols="12">
							<v-data-table disable-pagination :headers="headers" :items="dataProduct" hide-default-footer no-data-text="Belum ada data tersedia">
								<template v-slot:item.product_name="{ item }">
									<div class="pt-2">{{ item.pdor_detail_product_name }}</div>
								</template>
								<template v-slot:item.quantity_sent="{ item }">
									<div class="pt-2">{{ item.pdor_detail_quantity_sent | toNumber }}</div>
								</template>
								<template v-slot:item.quantity="{ item }">
									<!-- <div class="pt-2">{{ item.quantity | toNumber }}</div> -->
									<v-currency-field v-model.lazy="item.quantity" :rules="[inputrules.required, inputrules.notnull]" outlined dense hide-details="auto" background-color="white" class="py-3 details-mb-0"></v-currency-field>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-form>
			</v-card-text>
			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" v-if="!pdor_code" disabled outlined class="text-capitalize">
					<div>Proses Penerimaan</div>
				</v-btn>
				<v-btn v-else depressed class="text-capitalize" color="primary darken-1" type="submit" @click="approve">
					<div>Proses Penerimaan</div>
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			pdor_code: '',
			headers: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Jumlah Dikirim', value: 'quantity_sent', sortable: false, align: 'center'},
			{ text: 'Jumlah Diterima', value: 'quantity', sortable: false, align: 'center'},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('pdoRetur', ['detailRD', 'response', 'responseError', 'RDforReceive', 'alertMultiple']),

		addresText() {
			var data = []
			if (this.detailRD) {
				if (this.detailRD.supplier_address)
					data.push(this.detailRD.supplier_address)
				if (this.detailRD.supplier_subdistrict_name)
					data.push(this.detailRD.supplier_subdistrict_name)
				if (this.detailRD.supplier_city_name)
					data.push(this.detailRD.supplier_city_name)
				if (this.detailRD.supplier_province_name)
					data.push(this.detailRD.supplier_province_name)
			}
			return data.join(', ')
		},
		dataProduct() {
			if (this.detailRD.pdor_detail) {
				return this.detailRD.pdor_detail.map( (el) => {
					el.quantity = el.pdor_detail_quantity_sent
					return el
				})
			} else {
				return []
			}
		}
	},
	methods: {
		...mapActions('pdoRetur', ['getDetailRD',  'receiveRD', 'rejectRetur', 'getRDforReceive']),
		...mapMutations('pdoRetur', ['setDetailRD', 'clearDataReturDelivery']),
		...mapMutations(['setOverlay']),

		getDetail(code) {
			if (code) {
				this.getDetailRD(code)
			} else {
				this.setDetailRD({})
			}
		},
		approve(){
			this.poProccess = 'approve'
			let msg = "Yakin akan memproses Retur ini?"
			this.$refs.modalReceiveReturDelivery.setMessage(msg)
			this.$refs.modalReceiveReturDelivery.showConfirm()
		},
		async receiveDelivery() {
			await this.setOverlay(true)
			await this.$refs.modalReceiveReturDelivery.hideConfirm()
			var product = await this.dataProduct.map( el => {
				return {
					product_id : el.pdor_detail_product_id,
					product_name : el.pdor_detail_product_name,
					quantity : el.quantity,
				}
			})
			await this.receiveRD({
				pdor_id : this.detailRD.pdor_id,
				product : product
			}).then(() => {
				if (this.response.code == 200.) {
					this.pdor_code = ''
					this.setDetailRD({})
					this.getRDforReceive()
				}
				if (this.response.data.completed) {
					this.$refs.modalInfoReceiveReturDelivery.showConfirm()
					this.$refs.modalInfoReceiveReturDelivery.setMessage('Barang yang diterima sudah sesuai dengan jumlah Retur. Status Retur ini akan berubah menjadi Selesai.')
					this.$refs.modalInfoReceiveReturDelivery.setCloseText("OK")
				}
			})
			await this.setOverlay(false)
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Penerimaan Retur`);
		this.getRDforReceive().then(() => {
			if (this.$route.params.code) {
				this.pdor_code = this.$route.params.code
				this.getDetailRD(this.$route.params.code)
			}
		})
	},
	beforeDestroy() {
		this.clearDataReturDelivery()
	},
	watch: {
	}
}
</script>